module.exports = __webpack_public_path__ + "img/my_get.733f3f1.png";